import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import { Common } from "@root/components/common/CommonTypes";
import PatternSamples from "@root/ts/PatternSamples";
import { Emitter } from "strict-event-emitter";
import { gsap } from "gsap";

export default class VCodeInput extends ComponentBase implements Common.InputComponent
{
  regexp: RegExp;
  emitter: Emitter<{ change: [value: string, isOk: boolean] }>;
  _isOk: boolean = false;

  _input: HTMLInputElement;

  vcodeEmitter: Emitter<{ request: [], timeout: [] }>;

  _state: string = "default";

  _timerId: any;

  constructor(elem: ComponentElem)
  {
    super(elem);

    this.emitter = new Emitter();
    this.vcodeEmitter = new Emitter();
    this.regexp = PatternSamples["simple"];

    this._input = this.$root.find("input")[0];

    this.$root.find("input").on("input", () =>
    {
      this.update();
    });

    this.$root.find(".btn-send-vcode").on("click", (event: JQuery.ClickEvent) =>
    {
      event.preventDefault();
      if (this._state !== "countdown") this.vcodeEmitter.emit("request");
    });
  }

  changeState(state: string)
  {
    this._state = state;
    this.$root.attr("state", state);
  }

  getState()
  {
    return this._state;
  }

  countDown(duration: number)
  {
    if (this._timerId !== undefined) 
    {
      clearInterval(this._timerId);
      this._timerId = undefined;
    }

    this.changeState("countdown");

    let timeleft = duration,
      $countdown = this.$root.find(".countdown");

      
    $countdown.text(String(timeleft));

    // 需要使用 setInterval or setTimeout, 因為 gsap 在不會在背景更新時間
    this._timerId = setInterval(()=>
    {
      timeleft -= 1;
      $countdown.text(String(timeleft));

      if (timeleft <= 0) {
        clearInterval(this._timerId);
        this.vcodeEmitter.emit("timeout");
      }
      
    }, 1000);
  }

  update()
  {
    if (this.regexp) {
      this._isOk = this.regexp.test(this._input.value);
      this.emitter.emit("change", this._input.value, this._isOk);
    }
  }

  getValue()
  {
    return (<HTMLInputElement>this.$root.find("input")[0]).value;
  }


  isOk()
  {
    return this._isOk;
  }

  reset(): void
  {
    this._input.value = "";
    this.update();
  }
}